








import moment from 'moment';
import { Component, Mixins, Vue } from 'vue-property-decorator';
import UseFluid from '@/mixins/UseFluid';

@Component
export default class App extends Mixins(UseFluid) {
  public get year(): string {
    return moment().format('YYYY');
  }
  }
